<template>
  <div class="Contact">
    <top-page-title>Контакти</top-page-title>
    <section class="section Map"/>
    <section class="section pb-l bg-grey-light pt-1">
      <div class="container">
        <div class="contact-content md:flex -mt-8">
          <div class="left-row md:w-1/3 bg-red py-10 px-6 text-white">
            <h1 class="mb-10">Свържете се с нас</h1>
            <ul class="icon-list mb-10 pl-0">
              <li class="icon-list-item">
                <div class="icon">
                  <div class="mps mps-lg mps-phone"/>
                </div>
                <a
                  href="tel: +359 877 222 359"
                  class="text"
                >+359 877 222 359</a>
              </li>
              <li class="icon-list-item">
                <div class="icon">
                  <div class="mps mps-lg mps-envelope-o"/>
                </div>
                <div class="text"><a href="mailto:contact@mpsexpert.bg">contact@mpsexpert.bg</a></div>
              </li>
            </ul>
            <div class="flex text-2xl">
              <a
                target="_blank"
                class=""
                href="https://www.instagram.com/mps.expert/"
              >
                <v-icon type="instagram"/>
              </a>
              <a
                target="_blank"
                class="ml-4"
                href="https://www.youtube.com/channel/UCYJ6d7Ze_3VrgyuPqfSpdAw?"
              >
                <v-icon type="youtube"/>
              </a>
              <a
                target="_blank"
                class="ml-4"
                href="https://www.facebook.com/mpsexpert"
              >
                <v-icon type="facebook-square"/>
              </a>
            </div>
          </div>
          <div class="right-row md:w-2/3 bg-white p-12 lg:px-xl">
            <form @submit.prevent="submit">
              <form-wrapper :validator="$v.form">
                <form-field name="name">
                  <template slot-scope="{ attrs, events }">
                    <input
                      v-model.trim="form.name"
                      v-bind="attrs"
                      type="text"
                      v-on="events"
                    >
                  </template>
                </form-field>
                <form-field name="email">
                  <template slot-scope="{ attrs, events }">
                    <input
                      v-model.trim="form.email"
                      v-bind="attrs"
                      type="email"
                      v-on="events"
                    >
                  </template>
                </form-field>
                <form-field name="topic">
                  <template slot-scope="{ attrs, events }">
                    <input
                      v-model.trim="form.topic"
                      v-bind="attrs"
                      type="text"
                      v-on="events"
                    >
                  </template>
                </form-field>
                <form-field
                  class="border-b-0"
                  name="message"
                >
                  <template slot-scope="{ attrs, events }">
                    <textarea
                      v-model.trim="form.message"
                      v-bind="attrs"
                      cols="30"
                      rows="10"
                      v-on="events"
                    />
                  </template>
                </form-field>
                <div class="text-right">
                  <v-button
                    :loading="form.isLoading"
                    color="is-orange"
                    type="submit"
                  >
                    Изпрати
                  </v-button>
                </div>
              </form-wrapper>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Form } from '@/services/Form'
import { required, email } from 'vuelidate/lib/validators'

const form = new Form({
  name: { value: '', rules: { required } },
  email: { value: '', rules: { required, email } },
  topic: { value: '', rules: {} },
  message: { value: '', rules: { required } }
})

export default {
  data () {
    return {
      form
    }
  },
  methods: {
    submit () {
      this.$v.form.$touch()
      if (this.$v.form.$error) return
      // do some code
      this.form.post('contact-us')
        .then(() => {
          this.$notify.success('Message sent successfully')
          this.form.reset()
        })
        .catch((error) => {
          this.$displayError(error)
        })
    }
  },
  validations: {
    form: form.rules()
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

.icon-list-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  .icon {
    margin-right: map_get($margin, 3);
  }
}
</style>
